import { Services } from "../services";

export function StandardI18nAliases() {
    Services.translations.setAlias("err", "foo");

    Services.translations.setAlias("curr.inf", "infinity");

    // Autoplay
    Services.translations.setAlias("aut.swl", "single_win_limit_reached");
    Services.translations.setAlias("aut.lol", "loss_limit_reached");

    Services.translations.setFormat("debugRed", {
        fill: "red"
    });
}
